document.addEventListener('DOMContentLoaded', function () {

  /* FAQ accordion */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var btn = item.querySelector('.faq-question');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('open');
      item.closest('.faq-list').querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
      });
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* Product gallery thumbnails */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) main.src = thumb.dataset.full || thumb.src;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });

  /* Bundle offer selection */
  document.querySelectorAll('[data-bundle]').forEach(function (bundle) {
    var options = bundle.querySelectorAll('.bundle-option');
    var hiddenQty = document.querySelector('[data-bundle-qty-input]');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
        if (hiddenQty) hiddenQty.value = opt.dataset.qty || 1;
      });
    });
  });

  /* Countdown timer */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var minutes = parseInt(el.dataset.countdown || '15', 10);
    var end = Date.now() + minutes * 60 * 1000;
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var m = Math.floor(diff / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.querySelector('[data-cd-value]').textContent =
        String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      if (diff > 0) requestAnimationFrame(function () { setTimeout(tick, 1000); });
    }
    tick();
  });

  /* Review / GIF horizontal slider drag scroll (touch is native) */
  document.querySelectorAll('.track').forEach(function (track) {
    var isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach(function (evt) {
      track.addEventListener(evt, function () { isDown = false; });
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });
  });

  /* Sticky add-to-cart bar on mobile */
  var stickyBar = document.querySelector('.sticky-atc');
  var heroForm = document.querySelector('[data-product-form]');
  if (stickyBar && heroForm) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('active', !entry.isIntersecting);
      });
    });
    observer.observe(heroForm);
  }
});
